// Architectural summary: Single source of the category display-ordering convention — A→Z by Hebrew locale,
// uncategorized (null name) always last. Shared by the POS menu rail and the KDS overview grouping to prevent drift.
export function compareCategoryNamesForDisplay(a: string | null, b: string | null): number {
  if (a === null) return 1;
  if (b === null) return -1;
  return a.localeCompare(b, 'he');
}
